import { Record } from 'immutable';
import { makeInstructionalApp } from '../InstructionalApp';
export const INSTRUCTIONAL_INSTALL_MODE = 'INSTRUCTIONAL';
export const makeInstructionalInstallMode = Record({
  type: INSTRUCTIONAL_INSTALL_MODE,
  instructionalApp: makeInstructionalApp()
});